import { fluentProvide } from '@ldlework/inversify-binding-decorators';
import { interfaces } from 'inversify';

export const service = <T> (
  identifier: interfaces.ServiceIdentifier<T>,
  scope: interfaces.BindingScope = 'Singleton',
  force?: boolean,
) => {
  const syntax = fluentProvide(identifier);
  switch (scope) {
    case 'Request':
      syntax.inRequestScope();
      break;

    case 'Transient':
      syntax.inTransientScope();
      break;

    default:
      syntax.inSingletonScope();
  }

  return syntax.done(force);
};
